<template>
    <svg :class="svgClass" aria-hidden="true" >
      <use :xlink:href="'#'+iconName" />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'SvgIcon',
    props: {
      iconClass: {
        type: String,
        required: false
      },
      iconName: {
        type: String,
        default: ''
      }
    },
    computed: {
    //   iconName() {
    //     return `#${this.iconName}`
    //   },
      svgClass() {
        if (this.className) {
          return 'svg-icon ' + this.className
        } else {
          return 'svg-icon'
        }
      }
    },
  }
  </script>
  
  <style scoped>
  .svg-icon {
    width: 16px;
    height: 16px;
    vertical-align: -2px;
    fill: currentColor;
    overflow: hidden;
  }
  </style>